import { Icon, Tooltip } from "@chakra-ui/react";
import { PopoverGenero } from "../../components/PopoverGenero";
import { IoHelpCircle } from "react-icons/io5";

export const renderTooltip = (
  isMobile,
  placement,
  texto,
  isOpenTooltip,
  setIsOpenTooltip,
) => {
  if (isMobile) {
    return (
      <PopoverGenero
        isOpen={isOpenTooltip}
        setIsOpen={setIsOpenTooltip}
        flex={true}
        handleClick={() => setIsOpenTooltip(!isOpenTooltip)}
        labelTextoGenero={texto}
      />
    );
  }

  return (
    <Tooltip
      label={texto}
      fontSize="md"
      maxW="400px"
      textAlign="justify"
      placement={placement}
    >
      <span className="hint-tooltip" style={{ zIndex: 0 }}>
        <Icon
          aria-label="Aviso de pendente"
          color="#6B6C71"
          as={IoHelpCircle}
          boxSize="20px"
        />
      </span>
    </Tooltip>
  );
};
